const API_URL = 'https://api-instantfunding.if-security.com';
const GO_API_BASE_URL = 'https://api-instantfunding.if-security.com';
const environment = {
    API_BASE_URL: API_URL,
    GO_API_BASE_URL: GO_API_BASE_URL,
    FEATURES: {
        IS_PROP: true,
        PRODUCTS: true,
        HAS_TRIAL: false,
        PROP_SHOW_LEVERAGE: false
    },
    RECAPTCHA: {
        ENABLED: true,
        ENABLED_FORGOT_PASSWORD: true,
        SITE_KEY: '6LeCZ2wrAAAAAAWVmFSQf08dAYZha5pcP8fN5caT',
        SITE_KEY_INVISIBLE: '6Lf973YrAAAAABuvDAei_T04gB7Brda_OP-YY5oR'
    },
    DAILY_RESET_HOUR: 17,
    TIMEZONE: 'America/New_York',
    ECONOMIC_CALENDAR_BASE_URL: 'https://trading.if-security.com/calendar-widget.iife.js',
    INTERCOM_APP_ID: 'f5dl2ivf'
};
export default environment;
